import { Declaracion_Recepcion } from './../../../models/declaracion_recepcion.model';
import { Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';


declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-declaracion-recepcion',
  templateUrl: './declaracion-recepcion.component.html',
  styleUrls: ['./declaracion-recepcion.component.css'],
  providers: [FormService]
})
export class DeclaracionRecepcionComponent  {
  public rows = [];
  public actualRow;
  public declaracion_recepcion: Declaracion_Recepcion;
  public form;
  public formulario;

  public form151 = false;
  public form153 = false;
  public form272 = false;
  public form273 = false;

  constructor(public _formService: FormService, private fb: FormBuilder) {
    this.formulario = localStorage.getItem("form")

    if (this.formulario == "1-5.1") {
        this.form151 = true;
    }
    if (this.formulario == "1-5.3") {
        this.form153 = true;
    }
    if (this.formulario == "2-7.2") {
        this.form272 = true;
    }
    if (this.formulario == "2-7.3") {
        this.form273 = true;
    }

      this.form = new FormGroup({
        declara: new FormControl(''),
        plano: new FormControl(''),
        tipo: new FormControl(''),
        tipoProyecto: new FormControl(''),
        permisoProyecto: new FormControl(''),
        numeroProyecto: new FormControl(''),
        fechaProyecto: new FormControl(''),
        superficieProyecto: new FormControl(''),
        resolucionModificacion: new FormControl(''),
        fechaModificacion: new FormControl(''),
        tipoRecepcion: new FormControl(''),
        superficieRecepcion: new FormControl(''),
        destinoRecepcion: new FormControl(''),
        parteRecibe: new FormControl(''),
          
      })

      if (!JSON.parse(localStorage.getItem("declaracion_recepcion"))) {
          localStorage.setItem("declaracion_recepcion", JSON.stringify(this.rows));
      } else {
          this.rows = JSON.parse(localStorage.getItem("declaracion_recepcion"));
          this.form.controls['declara'].setValue(this.rows[0] ? this.rows[0].declara : '');
          this.form.controls['plano'].setValue(this.rows[0] ? this.rows[0].plano : '');
          this.form.controls['tipo'].setValue(this.rows[0] ? this.rows[0].tipo : '');
          this.form.controls['tipoProyecto'].setValue(this.rows[0] ? this.rows[0].tipoProyecto : '');
          this.form.controls['permisoProyecto'].setValue(this.rows[0] ? this.rows[0].permisoProyecto : '');
          this.form.controls['numeroProyecto'].setValue(this.rows[0] ? this.rows[0].numeroProyecto : '');
          this.form.controls['fechaProyecto'].setValue(this.rows[0] ? this.rows[0].fechaProyecto : '');
          this.form.controls['superficieProyecto'].setValue(this.rows[0] ? this.rows[0].superficieProyecto : '');
          this.form.controls['resolucionModificacion'].setValue(this.rows[0] ? this.rows[0].resolucionModificacion : '');
          this.form.controls['fechaModificacion'].setValue(this.rows[0] ? this.rows[0].fechaModificacion : '');
          this.form.controls['tipoRecepcion'].setValue(this.rows[0] ? this.rows[0].tipoRecepcion : '');
          this.form.controls['superficieRecepcion'].setValue(this.rows[0] ? this.rows[0].superficieRecepcion : '');
          this.form.controls['destinoRecepcion'].setValue(this.rows[0] ? this.rows[0].destinoRecepcion : '');
          this.form.controls['parteRecibe'].setValue(this.rows[0] ? this.rows[0].parteRecibe : '');
        
      }
      this.declaracion_recepcion = {
        declara: "",
        plano: "",
        tipo: "",
        tipoProyecto:  "",
        permisoProyecto:  "",
        numeroProyecto:  "",
        fechaProyecto:  "",
        superficieProyecto:  "",
        resolucionModificacion:  "",
        fechaModificacion:  "",
        tipoRecepcion: "",
        superficieRecepcion:  "",
        destinoRecepcion:  "",
        parteRecibe:  ""
         
      }
  }

  add_declaracion_recepcion() {
      //var checkDeclaracion = event.value;
      localStorage.setItem("declaracion_recepcion", JSON.stringify([]))
      this.actualRow = localStorage.getItem("declaracion_recepcion");
      this.rows = JSON.parse(this.actualRow);
      this.rows = this.rows.concat({
        declara: this.form.value.declara,
        plano: this.form.value.plano,
        tipo: this.form.value.tipo,
        tipoProyecto: this.form.value.tipoProyecto,
        permisoProyecto:   this.form.value.permisoProyecto,
        numeroProyecto:  this.form.value.numeroProyecto,
        fechaProyecto:   this.form.value.fechaProyecto,
        superficieProyecto:   this.form.value.superficieProyecto,
        resolucionModificacion:   this.form.value.resolucionModificacion,
        fechaModificacion:  this.form.value.fechaModificacion,
        tipoRecepcion:  this.form.value.tipoRecepcion,
        superficieRecepcion:   this.form.value.superficieRecepcion,
        destinoRecepcion:  this.form.value.destinoRecepcion,
        parteRecibe:  this.form.value.parteRecibe
      })

      localStorage.setItem("declaracion_recepcion", JSON.stringify(this.rows));
  }

  delete_declaracion_recepcion(id) {
      for (let x = 0; x < this.rows.length; x++) {
          if (id == x) {
              this.rows.splice(x, 1);
              localStorage.setItem("declaracion_recepcion", JSON.stringify(this.rows));
          }
      }
  }

}
